import ENDPOINT from "@/api/endpoints";
import { HTTP, buildQueries, HTTP_FILE } from "@/api/http-common";
import _cloneDeep from "lodash/cloneDeep";
import { formatAttachFilesData } from "@/utils/uploadFileUtils";

const formDataHeaderConfig = {
  headers: {
    "Content-Type": "multipart/form-data;",
  },
};
export function callApiGetCongViecPaging(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.CONG_VIEC.GET_CONG_VIEC_PAGING}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachCongViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.CONG_VIEC.GET_CONG_VIEC_CA_NHAN}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachCongViecByNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.CONG_VIEC.LAY_DANH_SACH_CV_BY_NHIEM_VU}${payload}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTaoCongViec(payload) {
  return HTTP({
    url: ENDPOINT.CONG_VIEC.TAO_MOI,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiSuaCongViec(payload) {
  return HTTP({
    url: ENDPOINT.CONG_VIEC.SUA_CONG_VIEC,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGanCongViec(payload) {
  return HTTP({
    url: ENDPOINT.CONG_VIEC.GAN_CONG_VIEC,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetDonViTaoCongViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.CONG_VIEC.LAY_DANH_SACH_DON_VI_TAO_CONG_VIEC}?${buildQueries(
        payload
      )}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDonViGanCongViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.CONG_VIEC.LAY_DANH_SACH_DON_VI_GAN_CONG_VIEC}?${buildQueries(
        payload
      )}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function callApiUploadFile(payload) {
  const formData = getFormDataFromPayload(payload);
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(
      ENDPOINT.NHIEM_VU.THEM_MOI_FILE,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getFormDataFromPayload(payload) {
  let formData = new FormData();
  for (let key in payload) {
    formData.append(key, payload[key]);
  }
  const fileUpload = _cloneDeep(payload.fileUpload);
  fileUpload.forEach((file, index) => {
    formData = formatAttachFilesData(file, index, formData, "CongViec");
  });

  return formData;
}

export function callApiGetTrangThaiCv() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.DANH_MUC.DANH_SACH_TRANG_THAI_CONG_VIEC)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function callApiLayChiTietCongViecNhiemVu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.CONG_VIEC.GET_CHI_TIET_CONG_VIEC}${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiXoaCongViec(payload) {
  return HTTP({
    url: `${ENDPOINT.CONG_VIEC.XOA_CONG_VIEC}?congViecId=${payload.Id}`,
    method: "POST",
    asyncLoading: true,
  });
}

export function callApiHuyCongViec(payload) {
  return HTTP({
    url: `${ENDPOINT.CONG_VIEC.HUY_CONG_VIEC}?congViecId=${payload.Id}`,
    method: "POST",
    asyncLoading: true,
  });
}

export function callApiLayDanhSachLichSuThayDoiTrangThaiCongViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.CONG_VIEC.LAY_DANH_SACH_LICH_SU_THAY_DOI_TRANG_THAI}?congViecId=${payload}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuGiaoViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.CONG_VIEC.LAY_DANH_SACH_LICH_SU_GIAO_VIEC}?congViecId=${payload}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachMucDoCongViec() {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.CONG_VIEC.LAY_DANH_SACH_MUC_DO_CONG_VIEC}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
